<div *ngIf="!isMovil">
  <dx-data-grid
    class="tech-table-info"
    [columns]="colsTrades"
    [dataSource]="dataSource"
    [showBorders]="false"
    [showColumnLines]="false"
    [showRowLines]="true"
    [columnAutoWidth]="true"
    [wordWrapEnabled]="false"
    [paging]="false"
    [showColumnHeaders]="false"
    (onRowExpanded)="onRowExpanded($event)"
    hoverStateEnabled="true"
    (onRowClick)="onRowClick($event)"
    (onRowCollapsed)="onRowCollapsed($event)"
    (onCellPrepared)="onCellPrepared($event)"
  >
    <!--
      <dxo-sorting mode="none"></dxo-sorting>
      <div
        *dxTemplate="let row of 'templateName'"
        class="blue2 assetProfile div-ellipsis myTooltip"
        attr.data-code="{{ row.data.Code }}"
        attr.data-id="{{ row.data.Id }}"
        title="{{ row.data.ProductName }}"
      >
        {{ row.data.ProductName }}
      </div>
    -->

    <!-- Columnas de tabla-->
    <dxi-column
      dataField="ProductName"
      caption="texto"
      width="50%"
      cellTemplate="templateName"
      hidingPriority="0"
    ></dxi-column>

    <!--Es para poner el boton de expandir salga al final del todo-->
    <dxi-column type="detailExpand"></dxi-column>
    <dxo-selection mode="single"></dxo-selection>
    <!-- Desactiva cualquier tipo de ordenación-->
    <dxo-sorting mode="none"></dxo-sorting>

    <!--Para visualizar detalle dentro de la tabla -->
    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>

    <!-- Plantillas para celdas con html-->
    <!--<div *dxTemplate="let row of 'groupCellTemplate'">{{ row.value }}</div>-->
    <div *dxTemplate="let row of 'templateName'">
      <section class="tech-table-info-01 principal">
        <div class="info-A">
          <div class="logo-name {{ getColorById(row.row.data.Id) }}">
            {{ row.data.ProductName | uppercase | slice : 0 : 2 }}
          </div>
        </div>
        <div class="info-B">
          <p>{{ row.data.ProductName }}</p>
          <p>{{ row.data.TradeName}} | {{ row.data.ValueDate | date : dateFormat }}</p>
        </div>

        <div class="info-C">
          <div>
            {{ row.data.Amount | trCurrency : row.data.Currency }}
          </div>
          <div>
            {{ row.data.NumberOfShares | trDouble }}
          </div>
        </div>
      </section>
    </div>

    <!-- Plantillas para celdas con html en el masterdetail-->
    <div
      *dxTemplate="let row of 'detail'"
      class="detailswrapper opendetails_animation"
    >
      <div class="tech-table-info-01 details">
        <div class="item">
          <span>{{ 'k000999' | translate }}</span>
          <span>
            {{ row.data.TradeName }}
          </span>
        </div>

        <div class="item">
          <span>{{ 'k002802' | translate }}</span>
          <span>
            {{ row.data.ValueDate | date : dateFormat }}
          </span>
        </div>

        <div class="item">
          <span>{{ 'k000306' | translate }}</span>
          <span>
            {{ row.data.Amount | trCurrency : row.data.Currency }}
          </span>
        </div>

        <div class="item">
          <span>{{ 'k001810' | translate }}</span>
          <span>
            {{ row.data.NumberOfShares | trDouble }}
          </span>
        </div>

        <div class="item">
          <span>{{ 'k000048' | translate }}</span>

          <span
            *ngIf="row.data.Behavior === 'B' && row.data.QuotationType === 'N'"
          >
            {{ row.data.TradePrice }} %
          </span>
          <span
            *ngIf="row.data.Behavior !== 'B' && row.data.QuotationType !== 'N'"
          >
            {{ row.data.TradePrice | trCurrency : row.data.PriceCurrency }}
          </span>
        </div>

        <div class="item">
          <span>{{ 'k000298' | translate }}</span>
          <span>
            {{ row.data.ExhangeRate | trDouble }}
          </span>
        </div>

        <div class="item">
          <span>{{ 'k002352' | translate }}</span>
          <span>
            {{ row.data.Commisions | trCurrency : row.data.Currency }}
          </span>
        </div>

        <div class="item">
          <span>{{ 'k000159' | translate }}</span>
          <span>
            {{ row.data.Isin | trDashEmpty }}
          </span>
        </div>
      </div>
    </div>
  </dx-data-grid>
</div>

<div *ngIf="isMovil">
  <!--Tabla que no muestro lineas en la columnas, ni paginado ni cabeceras, utilizo aqui solo el onRowPrepared!-->
  <dx-data-grid
    class="tech-table-info"
    [columns]="colsTrades"
    [dataSource]="dataSource"
    [showBorders]="false"
    [showColumnLines]="false"
    [showRowLines]="true"
    [columnAutoWidth]="false"
    [wordWrapEnabled]="true"
    [paging]="false"
    [showColumnHeaders]="false"
  >
    <!-- Columnas de tabla-->
    <dxi-column
      dataField="ProductName"
      caption="texto"
      width="100%"
      cellTemplate="templateMobile"
      hidingPriority="0"
    ></dxi-column>

    <!-- Desactiva cualquier tipo de ordenación-->
    <dxo-sorting mode="none"></dxo-sorting>

    <!-- Plantillas para celdas con html en el interior -->
    <div *dxTemplate="let row of 'templateMobile'">
      <div class="tech-table-info-01 principal" (click)="openDetail(row.data)">
        <div class="info-A">
          <div class="logo-name {{ getColorById(row.row.data.Id) }}">
            {{ row.data.ProductName | uppercase | slice : 0 : 2 }}
          </div>
        </div>
        <div class="info-B">
          <p>{{ row.data.ProductName }}</p>
          <p>{{ row.data.TradeName}} | {{ row.data.ValueDate | date : dateFormat}}</p>
        </div>

        <div class="info-C">
          <div>
            {{ row.data.Amount | trCurrency : row.data.Currency : '1.2-2' }}
          </div>
          <div>
            {{ row.data.NumberOfShares | trDouble }}
          </div>
        </div>
      </div>
    </div>
  </dx-data-grid>
</div>
